module.exports = __webpack_public_path__ + "img/concept4.3cced6b9.png";